import { createTranslationResource } from '@backstage/frontend-plugin-api';
import { kubernetesReactTranslationRef } from '@backstage/plugin-kubernetes-react';

export const kubernetesReactTranslations = createTranslationResource({
  ref: kubernetesReactTranslationRef,
  translations: {
    'pt-BR': () => import('./pt-BR'),
  },
});
